import React from "react";
import BinIcon from "../../../../components/icon/Icon";
import { TYPE_TX } from "../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants";

export const getMobileHistoryTransactionIconByTxType = (type) => {
    switch (type) {
        case TYPE_TX.DEPOSIT:
            return 'IcPlusCircleWhite';
        case TYPE_TX.BONUS_CREDIT:
        case TYPE_TX.BONUS_REDUCE:
        case TYPE_TX.BONUS_REFUND:
            return 'IcBonusTransaction';
        case TYPE_TX.ADJUSTMENT:
            return 'IcAttentionCircleWhite';
        case TYPE_TX.WITHDRAW:
            return 'IcCard';
        case TYPE_TX.RESPAWN:
            return 'IcRebuy';
        case TYPE_TX.REFUND_AFTER_CANCELED:
            return 'IcRebuy';
        case TYPE_TX.CASHBACK:
            return 'IcCashback';
        case TYPE_TX.COMMISSION:
        case TYPE_TX.DEDUCTION:
            return 'IcMinusCircleWhite';
        case TYPE_TX.REFERRAL:
            return 'IcTicketCheck';
        case TYPE_TX.REFERRER:
            return 'IcTicketAdd';
        default:
            return 'IcAttentionCircleWhite'
    }
}

function MobileHistoryTransactionIcon(props) {
    const { item } = props;
    return <BinIcon name={getMobileHistoryTransactionIconByTxType(item.type)}
                    style={{ fill: 'var(--color-white-60)' }}/>
}

export default MobileHistoryTransactionIcon;
